import { render } from "./standardPage.vue?vue&type=template&id=4830c9bc&scoped=true&ts=true"
import script from "./standardPage.vue?vue&type=script&lang=ts"
export * from "./standardPage.vue?vue&type=script&lang=ts"

import "./standardPage.vue?vue&type=style&index=0&id=4830c9bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4830c9bc"]])

export default __exports__